import React from "react";
import POLineAuditReport from "../../../common/reports/audit/poLineAuditReport";

const POLineAuditIndex = props => {
  return <POLineAuditReport collabType="CMO" {...props} />;
};

export default POLineAuditIndex;
